// An invite link opened while signed out is kept here, so the invite is accepted
// once the user signs in — even after signing up and verifying their email.
const KEY = 'gb.pendingInvite';

export function savePendingInvite(token) {
  try { if (token) localStorage.setItem(KEY, token); } catch { /* storage unavailable */ }
}

export function loadPendingInvite() {
  try { return localStorage.getItem(KEY) || null; } catch { return null; }
}

export function clearPendingInvite() {
  try { localStorage.removeItem(KEY); } catch { /* storage unavailable */ }
}
